import DataTable from "react-data-table-component";

const customStyles = {
  headCells: {
    style: {
      color: "#979797",
      fontWeight: "500",
      fontSize: "17px",
      borderBottom: "1px solid #E6E7E8",
    },
  },
  rowCells: {
    style: {
      border: "none !important",
    },
  },
};

function SearchBar({ q, setQ }) {
  return (
    <input
      className="placeholder:textpwpw-grey2 lg:w-[600px] placeholder:text-sm mr-auto h-[52px] border border-[#E6E7E8] px-5 focus:outline-none rounded-[30px] max-w-[600px] mb-[40px]"
      type="text"
      value={q}
      onChange={({ target: { value } }) => setQ(value)}
      placeholder="Search"
    />
  );
}

const CustomTable = ({
  columns,
  data,
  searchBar = false,
  searchValue,
  setSearchValue,
  ...rest
}) => {
  return (
    <DataTable
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{ noRowsPerPage: true }}
      subHeader
      subHeaderComponent={
        searchBar ? (
          <SearchBar q={searchValue} setQ={setSearchValue} />
        ) : (
          <div />
        )
      }
      customStyles={customStyles}
      {...rest}
    />
  );
};

export default CustomTable;
